var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as main from "../export";
import { Apikey } from "./ApikeyManager";
import axios from "axios";
/**
 * @interface
 *
 * @name ATRDeviceManager
 * @description Interface exposed by api-key manager Asset-Tracking microservice
 * @author STMicroelectronics, Davide Sergi
 */
export class ATRApikeyManager {
    constructor(baseUrl, authorizer, region) {
        this.baseUrl = baseUrl;
        this.authorizer = authorizer;
        this.region = region;
    }
    getApikeys(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/apikeys`, this.baseUrl.href);
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "GET", url.hostname, url.pathname, url.search, "", "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders
            };
            const response = yield axios.get(url.href, opt);
            return response.data.map((d) => this.deserializeApikey(d));
        });
    }
    getApikey(id, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/apikeys/${id}`, this.baseUrl.href);
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "GET", url.hostname, url.pathname, url.search, "", "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders
            };
            const response = yield axios.get(url.href, opt);
            return this.deserializeApikey(response);
        });
    }
    createApikey(apikey, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/apikeys`, this.baseUrl.href);
            let rawApikey = {
                label: apikey.label,
            };
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "POST", url.hostname, url.pathname, url.search, JSON.stringify(rawApikey), "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders
            };
            yield axios.post(url.href, rawApikey, opt);
        });
    }
    updateApikey(apikey, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/apikeys/${apikey.id}`, this.baseUrl.href);
            let rawApikey = {
                enabled: apikey.enabled,
                label: apikey.label,
            };
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "PUT", url.hostname, url.pathname, url.search, JSON.stringify(rawApikey), "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders
            };
            yield axios.put(url.href, rawApikey, opt);
        });
    }
    deleteApikey(id, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/apikeys/${id}`, this.baseUrl.href);
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "DELETE", url.hostname, url.pathname, url.search, "", "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders
            };
            yield axios.delete(url.href, opt);
        });
    }
    deserializeApikey(rawApikey) {
        return new Apikey(rawApikey.apikey, rawApikey.label, rawApikey.enabled, new Date(rawApikey.create_timestamp), new Date(rawApikey.enabled_update_timestamp), rawApikey.owner + "." + rawApikey.apikey);
    }
}
//# sourceMappingURL=ATRApikeyManager.js.map